var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 my-2 div-progress-bar"},[_c('b-progress',{staticClass:"mb-2",attrs:{"max":_vm.maxValue,"value":_vm.value,"height":"8px"}}),_c('p',[_vm._v(_vm._s(_vm.labelProgress))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }